export const PRIMARY = "#0030a8";
export const BLUEMONEDD = "#0030a8";
export const BLUEMONEDDRGB = "rgba(0,48,168,0.80)";
export const BLUEMONEDDRGB2 = "rgba(0,48,168,1)";
export const BLUEMONEDDBUTTONS = "#1C3E92";
export const BLUEMONEDDBACKGROUND = "#0B2760";
export const BLUEMONEDDINFOMODAL = "#3A67C1";
export const YELLOWMONEDD = "#ffee25";
export const YELLOWMONEDDRGB = "rgba(255,238,37,0.55)";
export const ORANGEMONEDD = "#ee8233";
export const ORANGEMONEDDRGB = "rgba(238,130,51,0.65)";
export const REDMONEDD = "#8E1414";
export const REDMONEDDRGB = "rgba(170,49,45,0.55)";
export const VARIANT = "#0078d4";
export const SECONDARY = "#ffc107";
export const SUCCESS = "#28a745";
export const DANGER = "#dc3545";
export const WARNING = "#ffc107";
export const INFO = "#17a2b8";
export const LIGHT = "#f8f9fa";
export const DARK = "#343a40";
export const WHITE = "#fff";
export const BLACK = "#000";
export const GRAY = "#6c757d";
export const GRAY_LIGHT = "#f8f9fa";
export const GRAY_DARK = "#343a40";
export const GRAY_LIGHTER = "#e9ecef";
export const GRAY_DARKER = "#adb5bd";
export const GRAY_LIGHTEST = "#f5f6f7";
export const GRAY_DARKEST = "#343a40";
export const GRAY_NEUTRAL = "#6c757d";
export const GRAY_NEUTRAL_LIGHT = "#e9ecef";
export const GRAY_NEUTRAL_DARK = "#adb5bd";
export const GRAY_NEUTRAL_LIGHTEST = "#f5f6f7";
export const GREENMONEDD = "#4A783C";
//cores dos cards
export const GREENCARD = "#09A40F";
export const BLUECARD = "#1C3E92";
export const REDCARD = "#D71010";
export const GRAYCARD = "#E1E1E1";
export const ICECARD = "#ECECEC";
